import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';

import { addLoginHandlers, initResetUpdateUserState } from '../utils/loginHandlers';
import { actionCreators } from '../actions';

const getBuyerHeaderClient = async ({ node, store, relayEnv }) => {
    const isDesktop = serverVars.get('settings.isDesktop');
    const isTablet = serverVars.get('settings.isTablet');

    let navPromise;
    let messageBannerPromise = Promise.resolve({});

    if (isDesktop) {
        navPromise = import(
            /* webpackChunkName: "responsiveHeader" */ '../components/responsiveHeader'
        );
    } else {
        navPromise = import(/* webpackChunkName: "mobileHeader" */ '../components/mobileHeader');
    }

    if (isDesktop || isTablet) {
        messageBannerPromise = import(
            /* webpackChunkName: "MessageBanner" */ '../components/MessageBanner/MessageBanner'
        );
    }

    const { HeaderRenderer, headerRootQuery, headerInitialVariables } = await navPromise;
    const { default: MessageBannerRenderer } = await messageBannerPromise;

    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('messages');

    let props = {
        initialVariables: headerInitialVariables,
        environment: relayEnv,
        query: headerRootQuery,
    };

    if (MessageBannerRenderer) {
        props = {
            ...props,
            messageBannerRenderer: messageBannerRendererProps => (
                <MessageBannerRenderer {...messageBannerRendererProps} useGlobalFallbackMessage />
            ),
        };
    }

    addLoginHandlers(() => {
        store.dispatch(actionCreators.setUpdateUserState(true));
    });
    initResetUpdateUserState(() => store.dispatch(actionCreators.setUpdateUserState(false)));

    ReactDOM.hydrate(
        <IntlProvider locale={localeDataKey} messages={messages}>
            <Provider store={store}>
                <HeaderRenderer {...props} />
            </Provider>
        </IntlProvider>,
        node
    );

    return {
        store,
        getBuyerHeaderUiState: store.getState,
    };
};

export { getBuyerHeaderClient };
